const DROP_ZONE_CODE = {
  INVALID_TYPE: 'file-invalid-type',
  FILE_TOO_LARGE: 'file-too-large',
  TOO_MANY_FILE: 'too-many-files',
}

const HTTP_STATUS_CODE = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  PERMISSION_DENIED: 403,
  UNPROCESSABLE_ENTITY: 422,
  SERVER_ERROR: 500,
  NETWORK: 'ERR_NETWORK',
  NOT_FOUND: 404,
  CREATED: 201,
  CONFLICT: 409,
}

const ERROR_DETAIL_CODE = {
  TOKEN_INVALID: '401_3',
  TOKEN_EXPIRED: '401_4',
  PERMISSION_DENIED: '403_1',
  NOT_PREMIUM: '403_2',
  USER_INACTIVE: '403_3',
  IP_BLOCKED: '403_4',
  USER_NOT_FOUND: '404_1',
  BRANCH_NOT_FOUND: '404_2',
  COMPANY_NOT_FOUND: '404_4',
  EMISSION_NOT_FOUND: '404_16',
  REGISTER_DATA_NOT_FOUND: '404_14',
  VERSION_NOT_FOUND: '404_24',
  BRANCH_ITEM_NOT_FOUND: '422_17',
  BRANCH_EXIST: '409_3',
  USER_ACTIVATED: '409_10',
  EXCEEDED_ALLOWED_CAPACITY: '413_1',
  USER_EXIST: '413_2',
  REQUEST_SHARE_EXIST: '413_3',
  INVALID_PASSWORD: '422_8',
  COMPANY_EXIST: '422_26',
  COMPANY_CODE_REQUEST_EXIST: '422_28',
  COMPANY_CODE_COLLABORATION_EXIST: '422_29',
  CONDITION_NAME_EXIST: '422_32',
  EMISSION_CUT_STRATEGY_NAME_EXIST: '422_33',
  VERSION_NAME_EXIST: '422_35',
  ITEM_NAME_EXIST: '422_37',
  REQUEST_CHANGE_EMAIL_EXIST_WITHIN_24_HOUR: '409_7',
  REQUEST_CHANGE_EMAIL_EXIST_LESS_30_DAY: '409_8',
  PASSWORD_INVALID: '422_27',
  EMAIL_IS_EXIST: '409_9',
  BRANCH_HAS_USER: '422_39',
}

const ERROR_DETAIL_CODE_UPLOAD_CSV = {
  BRANCH_NOT_FOUND: '404_2',
  FIELD_INVALID: '422_16',
  FILE_EMPTY: '404_15',
  EMISSION_NOT_FOUND: '404_16',
  BRANCH_ITEM_NOT_FOUND: '422_17',
  FIELD_IS_EMPTY: '422_23',
  TEMPLATE_FORMAT: '422_38',
}

const ERROR_DETAIL_CODE_GROUP = {
  GROUP_EXIST: '409_4',
  CAN_NOT_MOVE: '409_5',
}

export {
  DROP_ZONE_CODE,
  HTTP_STATUS_CODE,
  ERROR_DETAIL_CODE,
  ERROR_DETAIL_CODE_UPLOAD_CSV,
  ERROR_DETAIL_CODE_GROUP,
}
